import type { CommandMenuDesignTokens } from '@primeuix/themes/types/commandmenu';

export default {
    root: {
        background: '{content.background}',
        borderColor: '{content.border.color}',
        borderRadius: '{content.border.radius}',
        height: '25rem',
    },
    header: {
        padding: '0.375rem 1.125rem',
        background: '{content.background}',
        borderColor: '{content.border.color}',
    },
    input: {
        padding: '0.375rem 0',
        fontSize: '1rem',
        fontWeight: '{typography.font.weight}',
        color: '{form.field.color}',
        placeholderColor: '{form.field.placeholder.color}',
    },
    list: {
        padding: '0.375rem',
    },
    empty: {
        padding: '2rem 0',
        color: '{content.color}',
    },
    footer: {
        padding: '0.625rem 1.125rem',
        background: '{content.background}',
        borderColor: '{content.border.color}',
    },
} satisfies CommandMenuDesignTokens;
